import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import moment from 'moment';
import BaseModel from "./BaseModel";
import PaymentPlanRepayment from "./PaymentPlanRepayment";
var PaymentPlan = /*#__PURE__*/function (_BaseModel) {
  function PaymentPlan() {
    _classCallCheck(this, PaymentPlan);
    return _callSuper(this, PaymentPlan, arguments);
  }
  _inherits(PaymentPlan, _BaseModel);
  return _createClass(PaymentPlan, [{
    key: "repayments",
    value: function repayments() {
      return this.get('payments').map(function (repayment) {
        return new PaymentPlanRepayment(repayment);
      });
    }
  }, {
    key: "overdueRepayments",
    value: function overdueRepayments() {
      return this.repayments().filter(function (repayment) {
        return repayment.date() <= moment();
      });
    }
  }, {
    key: "total",
    value: function total() {
      return this.repayments().reduce(function (acc, curVal) {
        return acc + curVal.amount();
      }, 0);
    }
  }]);
}(BaseModel);
export default PaymentPlan;